import { Formik, Form } from "formik";
import { Box } from "@mui/material";
import { loginValidationSchema } from "../../utils/validationSchema";
import { useUserLogin } from "../../hooks/useUserQueries";
import CustomTextField from "../CustomTextField/CustomTextField";
import PropTypes from "prop-types";
import PrimaryButton from "../PrimaryButton/PrimaryButton";

export default function LoginForm({ colorScheme = "white" }) {
  const loginMutation = useUserLogin();
  const initialValues = {
    email: "",
    password: "",
  };

  const handleSubmit = (values, { setSubmitting }) => {
    loginMutation.mutate(values);
    setSubmitting(false);
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={loginValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <CustomTextField
            name="email"
            label="Correo electrónico"
            type="email"
            colorScheme={colorScheme}
          />
          <CustomTextField
            name="password"
            label="Contraseña"
            type="password"
            colorScheme={colorScheme}
            showErrorOnChange
          />

          <Box mt={2}>
            <PrimaryButton type={"submit"} disabled={isSubmitting}>
              Iniciar Sesión
            </PrimaryButton>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

LoginForm.propTypes = {
  colorScheme: PropTypes.oneOf(["white", "black"]),
};
